var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block hover:bg-gray-200 my-1 px-4 py-1 font-medium text-gray-800 cursor-pointer",on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }